var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThirdBaseTradeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.998,
    cy: 16,
    rx: 15.998,
    ry: 16,
    fill: "#046AEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8961 16C31.8961 24.7813 24.7783 31.9 15.998 31.9C7.21781 31.9 0.1 24.7813 0.1 16C0.1 7.21866 7.21781 0.1 15.998 0.1C24.7783 0.1 31.8961 7.21866 31.8961 16Z",
    stroke: "black",
    strokeOpacity: 0.73,
    strokeWidth: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.00159 17.1539H19.715C20.2592 17.1539 20.26 17.1539 20.2608 16.6071C20.2608 16.1835 20.2322 15.7567 20.2687 15.3355C20.3053 14.9143 20.1376 14.8324 19.75 14.834C16.1625 14.8475 12.5757 14.842 8.989 14.842H3C3.46949 8.56342 8.90241 2.96677 16.0552 3.00015C23.1746 3.03432 29.1549 8.90834 28.9936 16.2908C28.8427 23.2751 23.1437 28.9091 16.1489 28.9989C8.93736 29.0911 3.45519 23.4412 3.00159 17.1539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.65144 12.2902C6.97487 10.7647 8.13262 9.56524 8.72564 9.02106C10.4642 7.78809 11.3872 7.65541 12.5513 7.48805L12.5742 7.48476C14.3872 7.22406 18.3878 7.24807 20.0483 7.74051C22.1239 8.35606 23.3099 9.58715 24.0107 10.8718C24.7116 12.1564 25.5202 14.1904 25.0081 18.2583C24.5984 21.5127 22.8786 22.701 21.423 23.5039L19.024 24.735L16.1398 26.0196C14.792 25.4754 11.5843 24.098 9.53567 22.9418C6.9749 21.4966 6.4897 18.9006 6.35493 18.2583C6.06854 16.8934 6.30274 13.9349 6.65144 12.2902Z",
    fill: "url(#paint0_linear_1877_15083)",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.91075 18.2266L6.47266 18.2266L6.55324 18.6351L6.66068 19.0982L6.82184 19.5885L7.03672 20.106C8.47642 20.1278 9.59738 20.0969 9.74959 20.0243C10.0289 19.6539 9.96447 18.5988 9.91075 18.2266Z",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9141 11.851C10.6339 10.5596 8.96673 9.70477 8.32031 9.49851C10.0702 7.52063 12.2561 7.41157 14.396 7.3048L14.4424 7.30248C16.1928 7.21506 19.4371 7.3263 21.0951 8.1096C23.0882 9.05124 24.1925 10.7462 24.7043 12.3335C25.216 13.9208 25.3237 16.6381 25.1083 18.0101C24.8531 19.6349 24.3823 22.2517 22.1186 22.9066C19.6137 23.6312 16.4355 23.3891 13.7691 22.7721C11.4104 22.2263 11.1565 19.6267 11.0488 18.5234L11.0487 18.5231C10.941 17.42 11.2642 13.4652 10.9141 11.851Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 17.5039,
    y: 19.8672,
    width: 2.54214,
    height: 0.656114,
    rx: 0.328055,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.9125 19.172C13.2887 18.2607 11.7616 18.1685 11.0625 18.2499C11.1432 19.8229 11.2507 20.6094 11.9498 21.5857C12.5052 22.3614 13.4016 22.7519 14.3427 22.8604L14.3427 20.6365C14.3427 19.7415 14.0469 19.398 13.9125 19.172Z",
    stroke: "black",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.0312 12.108C9.73737 11.6735 8.68272 11.0867 8.11019 10.8047L7.5 12.4509C7.91583 12.5058 9.37577 13.2969 10.0764 14.5773L10.3702 13.0454C10.3551 12.9463 10.3007 12.5065 10.0312 12.108Z",
    fill: "#CAA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M10.602 22.4555L7.17188 20.2344L7.32259 20.5129L7.49483 20.8129C7.72397 21.1538 8.07443 21.6797 8.64712 22.1626C9.10539 22.5491 9.47352 22.8007 10.3901 23.2326L11.4976 23.802L14.2857 23.884L17.4019 23.9865L20.026 24.0685L21.7481 23.1869L21.9326 23.0434C19.8253 23.6155 15.9638 23.3875 13.7412 22.9784L10.602 22.4555Z",
    fill: "#7057F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.749 24.2109L14.4387 24.2109L15.6602 25.4822L12.749 24.2109Z",
    fill: "#383740"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.56176 18.6367L6.96484 18.6367L7.16986 19.271L9.49342 19.2928C9.60276 19.1529 9.60732 18.7971 9.56176 18.6367Z",
    fill: "#826CF7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.1123 24.2969L14.8972 24.2969L16.1875 25.6911L13.1123 24.2969Z",
    fill: "#634AE4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M11.2695 23.8867L20.249 24.1652L19.308 24.6664L18.9854 24.8334L18.7703 24.9448L16.1356 26.1421L14.8721 25.6131L13.6085 25.0283L11.2695 23.8867Z",
    fill: "#7057F0",
    stroke: "black",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.7472 24.293L14.7891 24.293L16.0273 25.6872L12.7472 24.293Z",
    fill: "#644AE7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 11.7227,
    y: 13.1406,
    width: 6.10934,
    height: 4.0187,
    rx: 2.00933,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    filter: "url(#filter0_f_1877_15083)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7201,
    cy: 15.0892,
    rx: 2.52867,
    ry: 1.56182,
    fill: "#046AEE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3",
    filter: "url(#filter1_f_1877_15083)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.6899,
    cy: 15.1804,
    rx: 1.61959,
    ry: 1.08669,
    fill: "#046AEE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    d: "M11.5796 13.1406L17.7909 13.1406L17.7909 11.9244L16.2895 9.12193L13.5335 11.5807L12.2378 11.9244L11.3945 12.4797L11.5796 13.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    x: 17.832,
    y: 13.1406,
    width: 0.943053,
    height: 3.77265,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    d: "M11.3935 17.0576L11.6806 16.463L11.7626 16.7706L11.947 16.9961L12.152 17.1191L12.357 17.1806L11.8409 17.5375L11.3935 17.0576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    d: "M18.3147 17.1543L17.9408 16.3441L17.8504 16.503L17.8094 16.708L17.6988 16.9131L17.5224 17.0566L17.3379 17.1386L17.1739 17.1796L17.0099 17.2977L17.6989 17.7921L18.3147 17.1543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    d: "M18.2587 17.1172L24.4501 17.1172L24.4501 18.0604L22.9535 20.2337L20.2063 18.3269L18.9148 18.0604L18.0742 17.6298L18.2587 17.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    d: "M18.4429 13.1016L24.6542 13.1016L24.0801 11.8854L22.153 9.59545L20.3968 11.5417L19.1011 11.8854L18.2578 12.4406L18.4429 13.1016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 18.0977,
    y: 13.3477,
    width: 0.492028,
    height: 3.77265,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_10",
    d: "M18.2607 17.0186L18.5477 16.424L18.6297 16.7315L18.8142 16.957L19.0192 17.08L19.2242 17.1415L18.7081 17.4985L18.2607 17.0186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    d: "M24.9226 17.1406L24.808 16.305L24.7176 16.4639L24.6766 16.669L24.566 16.874L24.3896 17.0175L24.2051 17.0995L24.0411 17.1406L23.8771 17.2586L24.566 17.753L24.9226 17.1406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 18.3672,
    y: 13.1406,
    width: 6.10934,
    height: 4.0187,
    rx: 2.00933,
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4",
    filter: "url(#filter2_f_1877_15083)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4063,
    cy: 15.1751,
    rx: 2.5899,
    ry: 1.56182,
    fill: "#046AEE"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    d: "M18.3341 17.5757L19.0759 17.2333L18.9304 17.1505L18.7427 17.1129L18.5549 17.0117L18.4235 16.85L18.3484 16.681L18.3109 16.5308L18.2028 16.3806L17.7501 17.0117L18.3341 17.5757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    x: 17.8711,
    y: 13.2656,
    width: 0.492028,
    height: 3.77265,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    filter: "url(#filter3_f_1877_15083)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4594,
    cy: 15.2117,
    rx: 1.61959,
    ry: 1.08669,
    fill: "#046AEE"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.9963 15.6331H14.9248C14.9875 15.6331 14.9876 15.6331 14.9877 15.5701C14.9877 15.5212 14.9844 15.4719 14.9886 15.4233C14.9929 15.3747 14.9735 15.3653 14.9288 15.3655C14.5148 15.367 14.101 15.3664 13.6871 15.3664H12.9961C13.0503 14.6419 13.6771 13.9962 14.5025 14C15.3239 14.004 16.014 14.6817 15.9954 15.5336C15.978 16.3394 15.3204 16.9895 14.5133 16.9999C13.6812 17.0105 13.0486 16.3586 12.9963 15.6331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M19.9963 15.6331H21.9248C21.9875 15.6331 21.9876 15.6331 21.9877 15.5701C21.9877 15.5212 21.9844 15.4719 21.9886 15.4233C21.9929 15.3747 21.9735 15.3653 21.9288 15.3655C21.5148 15.367 21.101 15.3664 20.6871 15.3664H19.9961C20.0503 14.6419 20.6771 13.9962 21.5025 14C22.3239 14.004 23.014 14.6817 22.9954 15.5336C22.978 16.3394 22.3204 16.9895 21.5133 16.9999C20.6812 17.0105 20.0486 16.3586 19.9963 15.6331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_15083",
    x: 11.4914,
    y: 12.8273,
    width: 6.45859,
    height: 4.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35,
    result: "effect1_foregroundBlur_1877_15083"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_15083",
    x: 12.2703,
    y: 13.2937,
    width: 4.83828,
    height: 3.77188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_1877_15083"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1877_15083",
    x: 18.1164,
    y: 12.9133,
    width: 6.57969,
    height: 4.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35,
    result: "effect1_foregroundBlur_1877_15083"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1877_15083",
    x: 19.0398,
    y: 13.325,
    width: 4.83828,
    height: 3.77188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4,
    result: "effect1_foregroundBlur_1877_15083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_15083",
    x1: 8.19466,
    y1: 9.80124,
    x2: 13.4983,
    y2: 26.0209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C981FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#B589FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491707,
    stopColor: "#AF86FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738033,
    stopColor: "#866FF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806CF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdBaseTradeIcon);
export default __webpack_public_path__ + "static/media/ThirdBaseTradeIcon.929b3d99a4409c724637c30579581d4b.svg";
export { ForwardRef as ReactComponent };